import { Button, Form, Input } from "antd";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { I18N_NS } from "Config/i18n";
import * as React from "react";
import { useTranslation } from "react-i18next";

interface BcfIssueEditCommentProps extends ModalComponentProps {
  record: API_BcfServerComment;
  onSubmit: (record: API_BcfServerComment) => Promise<void>;
}

export const BcfIssueEditComment = (props: BcfIssueEditCommentProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const [loading, setLoading] = React.useState(false);

  const handleFinish = async (values) => {
    try {
      setLoading(true);
      await props.onSubmit({ ...props.record, comment: values.comment });
      props.hideModal();
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onFinish={handleFinish} layout="vertical" initialValues={{ comment: props.record.comment }}>
      <Form.Item label={t("Comment")} name="comment" rules={[{ required: true, message: t("This field is required") }]}>
        <Input.TextArea rows={4} />
      </Form.Item>
      <div className="text-right">
        <Button type="primary" htmlType="submit" loading={loading}>
          {t("Submit")}
        </Button>
      </div>
    </Form>
  );
};
